/*!
 * Copyright © 2019-2020. Verizon Connect Ireland Limited. All rights reserved.
 */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { TooltipModule } from 'shared';

import { TachoMessageSectionModule } from '../tacho-message-section/tacho-message-section.module';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { TachoBalloonDrivingInfoComponent } from './tacho-balloon-driving-info.component';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
  declarations: [TachoBalloonDrivingInfoComponent],
  exports: [TachoBalloonDrivingInfoComponent],
  imports: [TooltipModule, MatIconModule, CommonModule, ClipboardModule, TachoMessageSectionModule, MatTooltipModule]
})
export class TachoBalloonDrivingInfoModule {}
